import { styled } from "@mui/material/styles";
import { colors } from "../styles";

const ContentBox = styled("div")({
  padding: "20px 30px",
  width: "100%",
  margin: "30px 0 0 0",
  border: `1px solid ${colors.gray_01}`,
  borderRadius: "4px",
  background: `${colors.white}`,
});

export const ContentHeader = styled("h2")(`
    font-weight: 600;
    font-size: 20px;
    color: ${colors.black_01};
    margin-bottom: 16px;
`);

export const ContentSubHeader = styled("h2")(`
    font-weight: 400;
    font-size: 16px;
    color: ${colors.gray};
    margin: 0;
`);

export default ContentBox;
